import getDefaultState from './defaults';

export default getDefaultState();



// WEBPACK FOOTER //
// ./src/store/modules/session/state.js